import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 13,
  medium: 8,
  small: 7,
  xSmall: 5
};
const FacebookFilledIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.788 23.2H12.595V15.099H11V12.3076H12.595V10.6318C12.595 8.35477 13.496 7 16.055 7H18.185V9.79236H16.854C15.858 9.79236 15.792 10.1824 15.792 10.9104L15.787 12.3076H18.2L17.918 15.099H15.787L15.788 23.2Z",
        fill: "currentColor"
      }
    )
  );
};
FacebookFilledIcon.iconName = "FacebookFilledIcon";

export { FacebookFilledIcon };
